import { ref, watch, computed } from '@vue/composition-api'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axiosIns from '@/axios'
import store from '@/store'
import { useRouter } from '@/@core/utils/utils'

export default function useCartsList() {
  // Use toast
  const toast = useToast()
  const { route } = useRouter()

  const refUserListTable = ref(null)

  
  const isFenomen = store.getters['user/isFenomen']

  // Table Handlers
  const tableColumns = [
    { key: 'id', sortable: true },
    { key: 'created_date', label: 'Ekleme Tarihi', sortable: true }, 
    { key: 'link', label: 'Paylaşım', sortable: true },
    { key: 'created_time', label: 'Event Saati', sortable: true, tdClass:"text-center", thClass:"text-center" },
    { key: 'product_id', label: 'Ürün ID', sortable: true },
    { key: 'product_name', label: 'Ürün Adı', sortable: true },
    { key: 'quantity', label: 'Adet'},
    { key: 'total_amount', label: 'Fiyat'},
    { key: 'show_details', label: 'CİHAZ BİLGİSİ'},
  ]
  
  if (!isFenomen && route.value.params.type === 'influencer') {
    tableColumns.splice(2, 0, { key: 'influencer', label: 'Fenomen', sortable: true })
  }else{
    tableColumns.splice(2, 0, { key: 'platform', label: 'Platform', sortable: true })
    tableColumns.splice(3, 0, { key: 'link_type', label: 'Kaynak', sortable: true })
  }
  const perPage = ref(10)
  const totalCarts = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('created_date')
  const isSortDirDesc = ref(true)
  const roleFilter = ref(null)
  const planFilter = ref(null)
  const statusFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refUserListTable.value ? refUserListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalCarts.value,
    }
  })

  const refetchData = () => {
    refUserListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, roleFilter, planFilter, statusFilter, () => route.value.params] , () => {
    refetchData()
  })

  const fetchCarts = (ctx, callback) => {

    const params = {
      q: searchQuery.value,
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      role: roleFilter.value,
      plan: planFilter.value,
      status: statusFilter.value,
      typeOf: route.value.params.type
    }

    axiosIns
      .get('/cart', { params })
      .then(response => {
        const { Carts, total } = response.data.data
        
        callback(Carts)
        totalCarts.value = total
      })
      .catch(error => {
        // 401 hatası değilse uyarı göster
        if (!error.response || error.response.status !== 401) {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Sepet datasında hata',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        }
      })
  }

  return {
    fetchCarts,
    tableColumns,
    perPage,
    currentPage,
    totalCarts,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refUserListTable,

    refetchData,

  }
}
